import type { FC } from "react";
import type { CostCurrency } from "./costApi";
import { costCurrencies } from "./costApi";
import { MenuItem, TextField } from "@mui/material";
import type { TextFieldProps } from "@mui/material/TextField";

interface Props {
  readonly value: CostCurrency | null;
  readonly onChange: (value: CostCurrency | null) => void;
  readonly slotProps?: TextFieldProps["slotProps"];
  readonly disabled?: boolean;
  readonly required?: boolean;
}

const EMPTY_VALUE = "";

const CostCurrencySelect: FC<Props> = ({ value, onChange, slotProps, disabled, required }) => {
  const values = [{ value: EMPTY_VALUE }, ...costCurrencies.map((c) => ({ value: c }))];
  return (
    <TextField
      label="Waluta"
      disabled={disabled}
      select
      required={required}
      value={value ?? EMPTY_VALUE}
      onChange={(e) => onChange(e.target.value === EMPTY_VALUE ? null : (e.target.value as CostCurrency))}
      fullWidth
      slotProps={slotProps}
    >
      {values.map((it) => (
        <MenuItem key={it.value ?? EMPTY_VALUE} value={it.value ?? EMPTY_VALUE}>
          {it.value ?? EMPTY_VALUE}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default CostCurrencySelect;
